import { Button, Modal, Form, Input, message } from "antd";
import API from "../../../../services/api-request";
import { getDataLogin } from "../../../../utils/getDataLogin";

const AddWarehouse = (props) => {
  const [addForm] = Form.useForm();

  const onFinish = async (values) => {
    const { name } = values;

    const dataForm = {
      name,
    };

    await API.Post("warehouse", dataForm)
      .then(() => {
        message.success("Warehouse has been added");
        props.onGetWarehouse();
        addForm.resetFields();
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
  };

  return (
    <>
      <Modal
        title="Add Warehouse"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please input name!" }]}
          >
            <Input placeholder="Input Name"/>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddWarehouse;
